/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 3:00 PM
 *
 */

import NavDropdown from 'components/layout/Sidebar/NavDropdown/NavDropdown';

export default NavDropdown;
